
import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import bulb from "../../../../assets/images/bulbpss.png";
import charticon from "../../../../assets/images/charticon.png";
import mortgageblogicon from "../../../../assets/images/mortgageblogicon.png";
import expiryclock from '../../../../assets/images/expiryclock.svg';
import askimg from "../../../../assets/homeimages/askbtn.svg";
import {  useTranslation } from "react-i18next";
import mortgageicon from '../../../../assets/askTheExpertImages/mortgagemenuicon.svg';
import './articleDetails.css';
import { decodeHtmlEntities, convertToCanadianDateTime } from "../../../../shared/helper";
const MortgageArticleDetailsJsx = (props) => {
  const {
    detailsData
  } = props;
  const { t } = useTranslation();
  useEffect(() => {
   
    window.scrollTo(0, 0);
  }, [])
  return (
    <>

<section className="mortgageblogdetails">
        <div className="container">
          <div className="blogsectionone">
            <div className="row">
              <div className="col-lg-6 co-sm-6">
                <div className="blogsectiononeleft">
                  <h1>{decodeHtmlEntities(detailsData?.title?.rendered)}</h1>
                  <p>{detailsData?.acf?.banner_sectionn.short_description}</p>
                  <div className="d-flex align-items-center justify-content-between">
          <p className="articlepublishdate "><span><img src={expiryclock} alt="clock"/></span>{convertToCanadianDateTime(detailsData?.date)}</p>
                  <div className="d-flex userdetails">
                    <div className="userphoto">
                      <img src={`https://ui-avatars.com/api/?name=${detailsData?.['_embedded']?.['author']?.[0]?.name}&rounded=true`} alt={`${detailsData?.['_embedded']?.['author']?.[0]?.name}`} />
                    </div>
                    <div className="username">{detailsData?.['_embedded']?.['author']?.[0]?.name}</div>
                  </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 co-sm-6">
                <div className="blogsectiononeright">
                  <img src={detailsData?.acf?.banner_sectionn?.image} alt="blogimage" />
                  <div className="tagreal"><span> <img src={mortgageicon} alt="Mortgage Icon"/></span>{detailsData?.['_embedded']?.['wp:term']?.[0]?.[0]?.name}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="blogsectiontwo">
          <h2 className="mb-4"><span><img src={mortgageblogicon} alt="mortgageblogicon"/></span>{detailsData?.acf?.info_section?.title}</h2>
            <div className="row">
            <div className="col-lg-3 col-sm-3">
              <div className="blogsectiontwoimage">
              <img src={detailsData?.acf?.info_section?.image} alt="blogimage" />
              </div>
            </div>
              <div className="col-lg-9 col-sm-9">
                <div className="blogsectiontwotext">    
                   {detailsData?.acf?.info_section?.description_points && detailsData?.acf?.info_section?.description_points.map((item,index) => (
                        <p key={index}>{item?.points}</p>
                      ))} 
                </div>
              </div>
            </div>
          </div>
          <div className="blogsectionthree">
            <h4>{detailsData?.acf?.description_section?.title}</h4>
            <div className="blogsectionthreenew">
            <div className="row">
              <div className="col-lg-5 col-sm-5">
                <div className="blogsectionthreeimage">
                  <img src={detailsData?.acf?.description_section?.image} alt="blogimage" />
                </div>
              </div>
              <div className="col-lg-7 col-sm-7">
                <div className="blogsectionthreetext">
                {detailsData?.acf?.description_section?.description_points && detailsData?.acf?.description_section?.description_points.map((item,index) => (
                        <p key={index}>{item?.points}</p>
                      ))}
                </div>
              </div>
            </div>
            </div>
          </div>
          <div className="blogsectionfour">
            <h2><span className="d-block d-lg-none d-sm-none d-md-none "><img src={charticon} alt="icon"/></span>{detailsData?.acf?.statistical_overview?.title}</h2>
            <div className="blogsectionfourinner">
              <div className="row">
                <div className="charticon"><img src={charticon} alt="charticon" /></div>
                <div className="col-lg-6 col-sm-6">
                  <div className="blogsectionfourinnertin">
                    <div className="blogsectionfourinnertinner">
                    <div className="blogsectionfourserialnumber">{detailsData?.acf?.statistical_overview?.info_block_1?.serial_number}</div>
                    <div className="blogsectionfourtext">
                      <h4>{detailsData?.acf?.statistical_overview?.info_block_1?.title}</h4>
                      <p>{detailsData?.acf?.statistical_overview?.info_block_1?.description}</p>
                    </div>
                  </div>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6">
                  <div className="blogsectionfourinnertin">
                  <div className="blogsectionfourinnertinner">
                    <div className="blogsectionfourserialnumber">{detailsData?.acf?.statistical_overview?.info_block_2?.serial_number}</div>
                    <div className="blogsectionfourtext">
                      <h4>{detailsData?.acf?.statistical_overview?.info_block_2?.title}</h4>
                      <p>{detailsData?.acf?.statistical_overview?.info_block_2?.description}</p>
                    </div>
                  </div>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6">
                  <div className="blogsectionfourinnertin">
                  <div className="blogsectionfourinnertinner">
                     <div className="blogsectionfourserialnumber">{detailsData?.acf?.statistical_overview?.info_block_3?.serial_number}</div>
                    <div className="blogsectionfourtext">
                      <h4>{detailsData?.acf?.statistical_overview?.info_block_3?.title}</h4>
                      <p>{detailsData?.acf?.statistical_overview?.info_block_3?.description}</p>
                    </div>
                  </div>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6">
                  <div className="blogsectionfourinnertin">
                  <div className="blogsectionfourinnertinner">
                    <div className="blogsectionfourserialnumber">{detailsData?.acf?.statistical_overview?.info_block_4?.serial_number}</div>
                    <div className="blogsectionfourtext">
                      <h4>{detailsData?.acf?.statistical_overview?.info_block_4?.title}</h4>
                      <p>{detailsData?.acf?.statistical_overview?.info_block_4?.description}</p>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
        
          <div className="twoadjust">
            <div className="row">
              <div className="col-lg-7 col-sm-7">
                  <div className="blogsectionfive">
                    <h4><span><img src={bulb} alt="bulbpss" /></span>{detailsData?.acf?.expert_tips?.title}</h4>
                        <div className="blogsectionfivelefttext">

                        {detailsData?.acf?.expert_tips?.description_points && detailsData?.acf?.expert_tips?.description_points.map((item,index) => (
                        <p key={index}>{item?.points}</p>
                      ))}
                        </div>
                    <div className="blogsixsectioninnerbtn">
                <Link to={'/AskTheExpert'}>
                  <div className={`askbutton`}>
                    <p className={`askres mb-0`}>{t("COMMON.ASKTHEEXPERTS")}</p>
                    <img src={askimg} alt="Ask now" />
                  </div>
                </Link>
              </div>
                  </div>
                  
              </div>
              <div className="col-lg-5 col-sm-5">
 <div className="blogsectionsix">
            <h4>{detailsData?.acf?.definition_block?.title}</h4>
            <div className="blogsectionthreeimage">
                  <img src={detailsData?.acf?.definition_block?.image} alt="blogimage" />
                </div>
                <div className="blogsectionsixlefttext">
                {detailsData?.acf?.definition_block?.description_points && detailsData?.acf?.definition_block?.description_points.map((item,index) => (
                        <p key={index}>{item?.points}</p>
                      ))}

                  
                </div>
          </div>

              </div>
            </div>
          </div>
                

          <div className="blogsectionseven"> 
            
                <div className="blogsectionseventext">
              <h4>{detailsData?.acf?.conclusion_section?.title}</h4>
                <div className="blogsectionsevenright ">   

                {detailsData?.acf?.conclusion_section?.description_points && detailsData?.acf?.conclusion_section?.description_points.map((item,index) => (
                        <p key={index}>{item?.points}</p>
                      ))}
              
                  </div>
                </div>
              
          </div>
          <div className="blogdisclaimer">
       <div className="disclaimerinner">
         <h2>{t("COMMON.Disclaimer_heading")}</h2>
         <p>{t("COMMON.Disclaimer_text")}</p>
       </div>
       </div>
        </div>
      </section>
    </>

  );
};

export default MortgageArticleDetailsJsx;